<div class="cf-dlg">
  <div class="cf-dlg-header">
    <div class="cf-dlg-icon cf-dlg-icon--blue"><mat-icon>sync</mat-icon></div>
    <div class="bcs-header-text">
      <h2 class="cf-dlg-title">Sincronizar con Bookcit</h2>
      <p class="cf-dlg-subtitle" *ngIf="data.contactName">{{ data.contactName }}</p>
    </div>
    <button mat-icon-button class="cf-dlg-close" (click)="cancel()" [disabled]="saving" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <app-loading-state *ngIf="loading" message="Cargando datos de sincronización…"></app-loading-state>
  <app-loading-state *ngIf="saving" message="Sincronizando con Bookcit…"></app-loading-state>

  <ng-container *ngIf="!loading && !saving && loadError">
    <div class="cf-dlg-body">
      <div class="cf-dlg-mismatch bcs-error">
        <mat-icon>error</mat-icon>
        <span>{{ loadError }}</span>
      </div>
    </div>
    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cerrar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="load()">
        <mat-icon>refresh</mat-icon> Reintentar
      </button>
    </div>
  </ng-container>

  <ng-container *ngIf="!loading && !saving && !loadError">
    <div class="cf-dlg-body">
      <div class="bcs-cols">
        <div class="bcs-col-hdr">
          <mat-icon class="bcs-icon bcs-icon--factu">business</mat-icon>
          <span>Handly</span>
        </div>
        <div></div>
        <div class="bcs-col-hdr">
          <mat-icon class="bcs-icon bcs-icon--bookcit">event_available</mat-icon>
          <span>Bookcit</span>
        </div>
      </div>

      <span class="cf-dlg-section__label bcs-label">Nombre</span>
      <div class="bcs-row">
        <div class="bcs-cell">
          <app-input inputType="text" placeholder="Nombre" [formControl]="form.get('factuName')"></app-input>
        </div>
        <div class="bcs-arrows">
          <button mat-icon-button class="bcs-arrow-btn" (click)="copyNameToBookit()" title="Copiar a Bookcit" aria-label="Copiar nombre a Bookcit"><mat-icon>chevron_right</mat-icon></button>
          <button mat-icon-button class="bcs-arrow-btn" (click)="copyNameFromBookit()" title="Copiar de Bookcit" aria-label="Copiar nombre de Bookcit"><mat-icon>chevron_left</mat-icon></button>
        </div>
        <div class="bcs-cell">
          <app-input inputType="text" placeholder="Nombre en Bookcit" [formControl]="form.get('bookitFirstName')"></app-input>
          <app-input inputType="text" placeholder="Apellido en Bookcit" [formControl]="form.get('bookitLastName')"></app-input>
        </div>
      </div>

      <span class="cf-dlg-section__label bcs-label">Email</span>
      <div class="bcs-row">
        <div class="bcs-cell">
          <app-input inputType="email" placeholder="Email" [formControl]="form.get('factuEmail')"></app-input>
        </div>
        <div class="bcs-arrows">
          <button mat-icon-button class="bcs-arrow-btn" (click)="copyEmailToBookit()" title="Copiar a Bookcit" aria-label="Copiar email a Bookcit"><mat-icon>chevron_right</mat-icon></button>
          <button mat-icon-button class="bcs-arrow-btn" (click)="copyEmailFromBookit()" title="Copiar de Bookcit" aria-label="Copiar email de Bookcit"><mat-icon>chevron_left</mat-icon></button>
        </div>
        <div class="bcs-cell">
          <app-input inputType="email" placeholder="Email en Bookcit" [formControl]="form.get('bookitEmail')"></app-input>
        </div>
      </div>

      <span class="cf-dlg-section__label bcs-label">Teléfono</span>
      <div class="bcs-row">
        <div class="bcs-cell">
          <app-input inputType="text" placeholder="Teléfono" [formControl]="form.get('factuPhone')"></app-input>
        </div>
        <div class="bcs-arrows">
          <button mat-icon-button class="bcs-arrow-btn" (click)="copyPhoneToBookit()" title="Copiar a Bookcit" aria-label="Copiar teléfono a Bookcit"><mat-icon>chevron_right</mat-icon></button>
          <button mat-icon-button class="bcs-arrow-btn" (click)="copyPhoneFromBookit()" title="Copiar de Bookcit" aria-label="Copiar teléfono de Bookcit"><mat-icon>chevron_left</mat-icon></button>
        </div>
        <div class="bcs-cell">
          <app-input inputType="text" placeholder="Teléfono en Bookcit" [formControl]="form.get('bookitPhone')"></app-input>
        </div>
      </div>
    </div>

    <div class="cf-dlg-footer">
      <button mat-stroked-button class="cf-dlg-btn-secondary" (click)="cancel()">Cancelar</button>
      <button mat-flat-button class="cf-dlg-btn-primary" (click)="save()">
        <mat-icon>sync</mat-icon> Sincronizar
      </button>
    </div>
  </ng-container>
</div>
